import { Component } from '@angular/core'
import { SharedService } from '@flowaccount/landing'
@Component({
  selector: 'flowaccount-business-registration-ads-vdo-invite',
  templateUrl: './business-registration-ads-vdo-invite.component.html',
  styleUrl: './business-registration-ads-vdo-invite.component.scss',
})
export class BusinessRegistrationAdsVdoInviteComponent {
  constructor(public sharedService: SharedService) {}
  linkVideo(youtubeURL: string) {
    return this.sharedService.openVideoTutorialModal(youtubeURL)
  }
}
